<template>
  <div>
    <section class="section hero is-small">
      <div class="hero-body">
        <div class="container">
          <h2 class="title is-3">{{ translations.welcome }}</h2>
          <h4 class="subtitle is-6 has-text-grey">
            Fleet overview — click any count to drill into the devices list.
          </h4>
        </div>
      </div>
    </section>

    <section class="section home-dashboard">
      <div class="container">
        <!-- Loading state -->
        <div v-if="loading" class="has-text-centered has-text-grey py-6">
          <span class="icon is-large">
            <i class="material-icons">hourglass_empty</i>
          </span>
          <p>Loading fleet data…</p>
        </div>

        <template v-else>
          <!-- SECTION A — Fleet by status -->
          <div class="section-header">
            <h3 class="section-title">Fleet by status</h3>
            <span class="section-hint">Click a card to open the Devices list filtered by that status</span>
          </div>

          <div class="columns is-multiline status-grid">
            <div
              v-for="card in statusCards"
              :key="card.status"
              class="column is-3"
            >
              <router-link
                :to="{ path: '/devices', query: { status: card.status } }"
                class="status-card"
                :class="[`status-${card.key}`, { 'is-alert': card.key === 'missing' && card.total > 0 }]"
              >
                <div class="status-card-head">
                  <span class="status-dot" :class="`dot-${card.key}`"></span>
                  <span class="status-label">{{ card.status }}</span>
                </div>
                <div class="status-count" :class="{ 'has-text-danger': card.key === 'missing' && card.total > 0 }">
                  {{ card.total }}
                </div>
                <div class="status-breakdown">{{ card.breakdown }}</div>
              </router-link>
            </div>
          </div>

          <!-- SECTION B + C -->
          <div class="columns is-variable is-4 mt-4">
            <!-- SECTION B — Category → Model breakdown -->
            <div class="column is-8">
              <div class="section-header">
                <h3 class="section-title">Breakdown by category → model</h3>
              </div>
              <div class="box breakdown-box">
                <div v-if="categoryBreakdown.length === 0" class="has-text-grey py-4 has-text-centered">
                  No devices.
                </div>
                <div
                  v-for="cat in categoryBreakdown"
                  :key="cat.name"
                  class="breakdown-category"
                >
                  <div
                    class="category-row"
                    @click="toggleCategory(cat.name)"
                  >
                    <span class="icon is-small category-caret">
                      <i class="material-icons">{{ isCollapsed(cat.name) ? 'chevron_right' : 'expand_more' }}</i>
                    </span>
                    <span class="category-name">{{ cat.name }}</span>
                    <span class="category-total">{{ cat.total }} total</span>
                  </div>
                  <div v-if="!isCollapsed(cat.name)" class="category-models">
                    <div
                      v-for="model in cat.models"
                      :key="cat.name + '::' + model.name"
                      class="model-row"
                    >
                      <router-link
                        class="model-name"
                        :to="{ path: '/devices', query: { category: cat.name, model: model.name } }"
                      >
                        <span class="model-branch">└─</span>
                        <span class="model-label">{{ model.name }}</span>
                        <span class="model-count">{{ model.total }}</span>
                      </router-link>
                      <div class="model-chips">
                        <router-link
                          v-for="chip in model.statusChips"
                          :key="chip.status"
                          class="chip"
                          :to="{ path: '/devices', query: { category: cat.name, model: model.name, status: chip.status } }"
                        >
                          <span class="status-dot" :class="`dot-${chip.key}`"></span>
                          {{ chip.status }}
                          <span class="chip-count">{{ chip.count }}</span>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- SECTION C — Active events -->
            <div class="column is-4">
              <div class="section-header">
                <h3 class="section-title">Active events</h3>
              </div>
              <div class="box events-box">
                <div v-if="activeEvents.length === 0" class="has-text-grey py-4 has-text-centered">
                  No active events.
                </div>
                <router-link
                  v-for="ev in activeEvents"
                  :key="ev.name"
                  :to="ev.id ? { path: `/events/view/${ev.id}` } : { path: '/devices', query: { event: ev.name } }"
                  class="event-row"
                >
                  <div class="event-row-head">
                    <span class="event-name">{{ ev.name }}</span>
                    <span class="event-count">{{ ev.total }}</span>
                  </div>
                  <div class="event-breakdown">{{ ev.breakdown }}</div>
                </router-link>
                <router-link to="/events" class="events-footer">
                  View all events →
                </router-link>
              </div>
            </div>
          </div>

        </template>
      </div>
    </section>
    <!-- <section class="section home">
      <div class="container">
        <div class="tile is-ancestor">
          <div class="tile is-3 is-parent is-vertical">
            <article class="tile is-child">
           
            </article>
          </div>
          <div class="tile is-parent is-vertical">
            <article class="tile is-child">
           
            </article>
          </div>
          <div class="tile is-vertical is-6">
            <div class="tile">
              <div class="tile is-parent is-vertical">
                <article class="tile is-child">
               
                </article>
                <article class="tile is-child">
                  <router-link to="/devices" class="box is-blue">
                    <div class="media">
                      <div class="media-content">
                        <h4 class="title is-3">{{translations.devices}}</h4>
                      </div>
                      <div class="media-right">
                        <span class="icon">
                          <i class="material-icons is-size-3">devices</i>
                        </span>
                      </div>
                    </div>
                    
                    <a
                      class="has-text-grey-dark is-size-5"
                    >{{translations.manage_devices}}</a>
                  </router-link>
                </article>
              </div>

              <div class="tile is-6 is-parent is-vertical">
                <article class="tile is-child">
             
                </article>
                <article class="tile is-child">
                  <router-link to="/devices/models" class="box is-blue">
                    <div class="media">
                      <div class="media-content">
                        <h4 class="title is-3">{{translations.models}}</h4>
                      </div>
                      <div class="media-right">
                        <span class="icon">
                          <i class="material-icons is-size-3">perm_device_information</i>
                        </span>
                      </div>
                    </div>
                    
                    <a
                      class="has-text-grey-dark is-size-5"
                    >{{translations.manage_models}}</a>
                  </router-link>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>-->
  </div>
</template>

<script lang="ts">
import { IDashboardTranslations } from '@/translations';
import { IStateDevice } from '@/store/modules/devices';
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

interface IStatusCard {
  status: string;
  key: string;
  total: number;
  breakdown: string;
}

interface IStatusChip {
  status: string;
  key: string;
  count: number;
}

interface IModelBreakdown {
  name: string;
  total: number;
  statusChips: IStatusChip[];
}

interface ICategoryBreakdown {
  name: string;
  total: number;
  models: IModelBreakdown[];
}

interface IActiveEvent {
  id?: number;
  name: string;
  total: number;
  breakdown: string;
}

// Status definitions — order matters for display. Keys are used for CSS class names.
const STATUS_DEFS: Array<{ status: string; key: string }> = [
  { status: 'In Use', key: 'inuse' },
  { status: 'Available', key: 'available' },
  { status: 'Repairing', key: 'repairing' },
  { status: 'Receiving', key: 'receiving' },
  { status: 'Missing', key: 'missing' },
];

const statusKey = (status: string): string => {
  const match = STATUS_DEFS.find(
    (s) => s.status.toLowerCase() === (status || '').toLowerCase(),
  );
  return match ? match.key : 'other';
};

const formatCategoryBreakdown = (counts: Record<string, number>): string => {
  const entries = Object.entries(counts).filter(([, v]) => v > 0);
  if (entries.length === 0) return '0 devices';
  // Put BEAMER first if present
  entries.sort((a, b) => {
    if (a[0] === 'BEAMER') return -1;
    if (b[0] === 'BEAMER') return 1;
    return b[1] - a[1];
  });
  return entries.map(([cat, count]) => `${count} ${cat}`).join(' · ');
};

@Component({
  name: 'Home',
})
class Home extends Vue {
  @Getter('getDashboardTranslations') public translations!: IDashboardTranslations;
  @Getter('getDevices') public devices!: IStateDevice[];
  @Getter('getDevicesState') public devicesState!: { loading: boolean; list: IStateDevice[] };
  @Getter('getEvents') public storeEvents!: Array<{ id?: number; name?: string }>;
  @Action('fetchDevices') public fetchDevices!: (params?: { page?: number; pageSize?: number; search?: string }) => void;
  @Action('fetchEvents') public fetchEvents!: (params?: { page?: number; pageSize?: number }) => void;

  public collapsedCategories: Record<string, boolean> = {};

  public created() {
    // Load the full fleet for aggregation. Use a large page size since the
    // backend supports it and the existing Devices page does the same.
    this.fetchDevices({ page: 1, pageSize: 1000 });
    // Events are needed to resolve event name -> id for the "Active events"
    // list navigation into the per-event detail page.
    this.fetchEvents({ page: 1, pageSize: 100 });
  }

  public get loading(): boolean {
    return this.devicesState.loading && this.devices.length === 0;
  }

  /** Section A — status cards. Only shows statuses that exist in data, plus
   *  the canonical four (In Use / Available / Repairing / Missing). */
  public get statusCards(): IStatusCard[] {
    const presentStatuses = new Set<string>();
    this.devices.forEach((d) => {
      if (d.status) presentStatuses.add(d.status);
    });

    const canonical = ['In Use', 'Available', 'Repairing', 'Missing'];
    canonical.forEach((s) => presentStatuses.add(s));

    const ordered: string[] = [];
    STATUS_DEFS.forEach((s) => {
      if (presentStatuses.has(s.status)) ordered.push(s.status);
    });
    // Any non-canonical statuses in data
    presentStatuses.forEach((s) => {
      if (!ordered.includes(s)) ordered.push(s);
    });

    return ordered.map((status) => {
      const devicesInStatus = this.devices.filter(
        (d) => (d.status || '').toLowerCase() === status.toLowerCase(),
      );
      const catCounts: Record<string, number> = {};
      devicesInStatus.forEach((d) => {
        const cat = d.category_name || 'UNCATEGORIZED';
        catCounts[cat] = (catCounts[cat] || 0) + 1;
      });
      return {
        status,
        key: statusKey(status),
        total: devicesInStatus.length,
        breakdown: formatCategoryBreakdown(catCounts),
      };
    });
  }

  /** Section B — category → model breakdown. */
  public get categoryBreakdown(): ICategoryBreakdown[] {
    const byCat: Record<string, Record<string, IStateDevice[]>> = {};
    this.devices.forEach((d) => {
      const cat = d.category_name || 'UNCATEGORIZED';
      const model = d.model_name || 'UNSPECIFIED';
      if (!byCat[cat]) byCat[cat] = {};
      if (!byCat[cat][model]) byCat[cat][model] = [];
      byCat[cat][model].push(d);
    });

    const cats: ICategoryBreakdown[] = Object.keys(byCat).map((catName) => {
      const models: IModelBreakdown[] = Object.keys(byCat[catName]).map((modelName) => {
        const modelDevices = byCat[catName][modelName];
        const statusChips: IStatusChip[] = STATUS_DEFS.map((def) => ({
          status: def.status,
          key: def.key,
          count: modelDevices.filter(
            (d) => (d.status || '').toLowerCase() === def.status.toLowerCase(),
          ).length,
        })).filter((c) => c.count > 0);
        return {
          name: modelName,
          total: modelDevices.length,
          statusChips,
        };
      }).sort((a, b) => b.total - a.total);

      return {
        name: catName,
        total: models.reduce((sum, m) => sum + m.total, 0),
        models,
      };
    }).sort((a, b) => b.total - a.total);

    return cats;
  }

  /** Section C — active events (devices with a current_event_name). Top 5. */
  public get activeEvents(): IActiveEvent[] {
    const byEvent: Record<string, IStateDevice[]> = {};
    this.devices.forEach((d) => {
      const name = d.current_event_name;
      if (!name) return;
      if (!byEvent[name]) byEvent[name] = [];
      byEvent[name].push(d);
    });

    return Object.keys(byEvent)
      .map((name) => {
        const list = byEvent[name];
        const catCounts: Record<string, number> = {};
        let id: number | undefined;
        list.forEach((d) => {
          const cat = d.category_name || 'UNCATEGORIZED';
          catCounts[cat] = (catCounts[cat] || 0) + 1;
          if (!id && d.current_event && d.current_event.id) {
            id = d.current_event.id;
          }
        });
        if (!id && this.storeEvents && this.storeEvents.length) {
          const match = this.storeEvents.find(
            (e) => (e.name || '').toLowerCase() === name.toLowerCase(),
          );
          if (match && match.id) id = match.id;
        }
        return {
          id,
          name,
          total: list.length,
          breakdown: formatCategoryBreakdown(catCounts),
        };
      })
      .sort((a, b) => b.total - a.total)
      .slice(0, 5);
  }

  public toggleCategory(name: string) {
    this.$set(this.collapsedCategories, name, !this.collapsedCategories[name]);
  }

  public isCollapsed(name: string): boolean {
    return !!this.collapsedCategories[name];
  }

}

export default Home;
</script>

<style scoped lang="scss">
$green: #3fb982;
$amber: #d9a14a;
$red: #d66060;
$blue: #4a90d6;
$grey-faint: #8a8a8a;

$surface: #1b2a44;
$surface-alt: #223250;
$border: rgba(255, 255, 255, 0.08);
$border-strong: rgba(255, 255, 255, 0.14);
$text: #e5e9f2;
$text-muted: #9aa6bf;
$text-faint: #6d7890;

.hero {
  padding-top: 1.5rem;
  padding-bottom: 0.5rem;
  .title { margin: 0 0 0.5rem; color: $text; }
  .subtitle { margin-top: 0 !important; color: $text-muted !important; }
}

.section-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 0.75rem;
}
.section-title {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: $text-muted;
  margin: 0;
}
.section-hint {
  font-size: 0.72rem;
  color: $text-faint;
}

.status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 0.35rem;
  vertical-align: middle;
}
.dot-inuse { background: $blue; }
.dot-available { background: $green; }
.dot-repairing { background: $amber; }
.dot-receiving { background: $amber; }
.dot-missing { background: $red; }
.dot-other { background: $grey-faint; }

// SECTION A — status cards
.status-grid { margin-top: 0; }

.status-card {
  display: block;
  background: $surface;
  border: 1px solid $border;
  border-radius: 6px;
  padding: 1.25rem;
  transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;
  color: $text;

  &:hover {
    border-color: $border-strong;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
    transform: translateY(-1px);
  }

  &.is-alert { border-color: rgba(214, 96, 96, 0.55); }
}
.status-card-head {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.6rem;
}
.status-label {
  font-size: 0.82rem;
  color: $text-muted;
}
.status-count {
  font-size: 2.25rem;
  font-weight: 300;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  margin-bottom: 0.5rem;
  color: $text;
}
.status-breakdown {
  font-size: 0.72rem;
  color: $text-faint;
}

// SECTION B — breakdown
.breakdown-box {
  padding: 0;
  background: $surface;
  border: 1px solid $border;
  color: $text;
  box-shadow: none;
}
.breakdown-category + .breakdown-category {
  border-top: 1px solid $border;
}
.category-row {
  display: flex;
  align-items: center;
  padding: 0.85rem 1rem;
  cursor: pointer;
  user-select: none;
  &:hover { background: $surface-alt; }
}
.category-caret { margin-right: 0.4rem; color: $text-faint; }
.category-name { font-weight: 600; color: $text; }
.category-total {
  margin-left: auto;
  color: $text-muted;
  font-size: 0.85rem;
  font-variant-numeric: tabular-nums;
}
.category-models { padding: 0 1rem 0.6rem 2rem; }
.model-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.55rem 0;
  border-top: 1px solid $border;
  flex-wrap: wrap;
}
.model-name {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  color: $text;
  &:hover { color: #8fb4ff; }
}
.model-branch { color: $text-faint; font-size: 0.75rem; }
.model-label { font-weight: 500; }
.model-count {
  color: $text-muted;
  font-size: 0.78rem;
  font-variant-numeric: tabular-nums;
}
.model-chips {
  display: flex;
  gap: 0.4rem;
  flex-wrap: wrap;
  margin-left: auto;
}
.chip {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  background: $surface-alt;
  border: 1px solid $border;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 0.72rem;
  color: $text-muted;
  &:hover {
    border-color: #8fb4ff;
    color: #cdd9f3;
  }
}
.chip-count {
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  margin-left: 0.15rem;
  color: $text;
}

// SECTION C — active events
.events-box {
  padding: 0;
  background: $surface;
  border: 1px solid $border;
  color: $text;
  box-shadow: none;
}
.event-row {
  display: block;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid $border;
  color: $text;
  &:hover { background: $surface-alt; }
}
.event-row-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 0.2rem;
}
.event-name {
  font-weight: 500;
  font-size: 0.9rem;
  margin-right: 0.5rem;
  color: $text;
}
.event-count {
  font-variant-numeric: tabular-nums;
  font-size: 0.9rem;
  color: $text;
}
.event-breakdown {
  font-size: 0.72rem;
  color: $text-faint;
}
.events-footer {
  display: block;
  text-align: center;
  padding: 0.65rem;
  font-size: 0.78rem;
  color: #8fb4ff;
  border-top: 1px solid $border;
  &:hover { background: $surface-alt; }
}
</style>